import { render, staticRenderFns } from "./ProcedureTNE.vue?vue&type=template&id=515082c6&scoped=true"
import script from "./ProcedureTNE.vue?vue&type=script&lang=js"
export * from "./ProcedureTNE.vue?vue&type=script&lang=js"
import style0 from "./ProcedureTNE.vue?vue&type=style&index=0&id=515082c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515082c6",
  null
  
)

export default component.exports